import { useMemo } from 'react';
import { Typography } from '@mui/material';
import { EventType } from 'main/store/schedule/state';

type Props = {
    title: EventType;
    place: string;
}

export const CalendarEvent = ({ title, place }: Props) => {

    const backgroundColor = useMemo(() => {
        switch (title) {
            case 'AM練習':
                switch (place) {
                    case '相模台小':
                        return '#4caf50';
                    case '桜台小':
                        return '#2e7d32';
                    default:
                        return '#1b5e20';
                }

            case 'PM練習':
                switch (place) {
                    case '相模台小':
                        return '#03a9f4';
                    case '桜台小':
                        return '#0288d1';
                    default:
                        return '#01579b';
                }

            case '公式戦':
                switch (place) {
                    case '相模台小':
                        return '#ef5350';
                    case '桜台小':
                        return '#d32f2f';
                    default:
                        return '#c62828';
                }

            case '練習試合':
                switch (place) {
                    case '相模台小':
                        return '#ff9800';
                    case '桜台小':
                        return '#ed6c02';
                    default:
                        return '#e65100';
                }
        }
    }, [title, place])

    return (
        <Typography color="white" variant="caption" sx={{ border: 1, backgroundColor }}>
            {title}
        </Typography>
    )
}
